<div class="panel" [ngClass]="{ open: isOpened }">
  <dx-button
    icon="close"
    stylingMode="text"
    (onClick)="onClosePanel()"
  ></dx-button>

  <div *ngIf="selectedEventLog">
    <div class="data-wrapper">
      <div class="d-title">Log Detay</div>
      <div [innerHTML]="selectedEventLog.requestContent"></div>
    </div>
  </div>
</div>
